import { Box, Container, Grid, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import CompanyDetails from "../components/settings/CompanyDetails";
import UserDetails from "../components/settings/UserDetails";
import RoleDetails from "../components/settings/RoleDetails";
import DocumentsDetails from "../components/settings/DocumentsDetails";
import RefferList from "../components/settings/manageReffer/RefferList";
import GeneralInfo from "../components/settings/GeneralInfo";
import OdtTemplate from "../components/settings/OdtTemplates/OdtTemplate";
import NoPermissionPage from "../../components/common/NoPermissionPage";
import { useSelector } from "react-redux";
import MaterialList from "../components/settings/materialList/MaterialList";
import VehicleTypeSetting from "../components/vehicles/VehicleTypeSetting";
import QuickBookLog from "../components/settings/QuickBook/QuickBookLog";
import SkillsList from "../components/settings/staffs/SkillsList";
import SalesList from "../components/settings/sales/SalesList";
import CustomerMerge from "../components/settings/customerMerge/CustomerMerge";
import ClientStorageManagement from "./ClientStorageManagement";
import SuperAdminEmailTemplate from "./SuperAdminEmailTemplate";
import SuperAdminSmsTemplate from "./SuperAdminSmsTemplate";
import MainSurveySettingPage from "../components/settings/surveySettings/MainSurveySettingPage";
import CustomerPortalSetting from "../components/settings/customerPortal/CustomerPortalSetting";
import LeadEmailAutomation from "../components/settings/LeadEmailAutomation";
import UnitSummary from "../components/storage/unitType/UnitSummary";
import StorageSettingTabs from "../components/storage/StorageSettingTabs";

const ClientAdminSetting = () => {
  const [value, setValue] = useState("0");
  const [communicationTab, setCommunicationTab] = useState(
    "leadEmailAutomation",
  );

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleCommunicationTabChange = (
    event: React.SyntheticEvent,
    newValue: string,
  ) => {
    setCommunicationTab(newValue);
  };

  const {
    user,
    userProfile,
    settingFeedbackModulePermission,
    settingDocumentModulePermission,
    permissions,
  } = useSelector((state: any) => state?.user);

  // ✅ COMMON ROLE CHECK
  const isOwnerOrTenantOrAdmin =
    user?.user?.roles?.includes("Owner") ||
    user?.user?.roles?.includes("TENANT") ||
    user?.user?.roles?.includes("Admin");

  const [isVehicleTypeSection, setIsVehicleTypeSection] = useState(
    userProfile?.features?.includes("Vehicle Type") || false,
  );

  const [isOperationsSection, setIsOperationsSection] = useState(
    userProfile?.features?.includes("Operations") || false,
  );

  useEffect(() => {
    setIsVehicleTypeSection(
      userProfile?.features?.includes("Vehicle Type") || false,
    );

    setIsOperationsSection(
      userProfile?.features?.includes("Operations") || false,
    );
  }, [userProfile]);
  console.log("process.env.NODE_ENV", process.env.NODE_ENV);

  return (
    <Grid
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 1, md: 1 }}
      container
      sx={{ height: "100vh", background: "#f4f4f4", paddingTop: "10px" }}
    >
      {/* LEFT SIDE VERTICAL TABS */}
      <Grid
        item
        xs={2}
        sx={{
          background: "#fff",
          borderRight: "1px solid #e0e0e0",
          height: "100vh",
          paddingLeft: "0px !important",
        }}
      >
        <Tabs
          orientation="vertical"
          value={value}
          onChange={handleChange}
          variant="scrollable"
          sx={{
            height: "100%",
            "& .MuiTab-root": {
              alignItems: "flex-start",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 600,
              color: "#666",
              padding: "12px 16px",
              borderBottom: "1px solid #f1f1f1",
            },
            "& .Mui-selected": {
              color: "#1B7B67",
              backgroundColor: "rgb(212,249,220)",
            },
            "& .MuiTabs-indicator": {
              left: 0,
              width: "4px",
              backgroundColor: "#1B7B67",
            },
          }}
        >
          <Tab value="0" label="Company Details" />
          {/* {process.env.NODE_ENV !== "production" && ( */}
          {/* <> */}
          <Tab value="19" label="Storage Settings" />
          <Tab value="15" label="Storage Site" />
          {/* </> */}
          {/* )} */}
          <Tab value="1" label="Role Details" />
          <Tab value="2" label="User Details" />
          {isVehicleTypeSection && <Tab value="3" label="Vehicle Types" />}
          <Tab value="4" label="Others" />
          <Tab value="5" label="Referrer Details" />
          <Tab value="6" label="Materials" />
          {/* {value === "7" && (
                    <>
                      <HtmlTemplateList />
                    </>
                  )} */}
          {/* {value === "8" && (
                  <>
                    <Editor placeholders={estimatePlaceholders} />
                  </>
                )} */}
          {isOperationsSection && <Tab value="11" label="Staff Skills" />}

          {isOperationsSection && <Tab value="12" label="Sales" />}

          {isOperationsSection && <Tab value="13" label="General" />}

          {/* {isOperationsSection && <Tab value="14" label="Customer Merge" />} */}

          <Tab value="10" label="Financial" />
          {isOperationsSection && <Tab value="16" label="Communications" />}
          {isOperationsSection && <Tab value="17" label="Survey Settings" />}
          {isOperationsSection && (
            <Tab value="18" label="Customer Portal Settings" />
          )}
        </Tabs>
      </Grid>

      {/* RIGHT SIDE CONTENT */}
      <Grid
        item
        xs={10}
        // sx={{
        //   // border: "1px solid #d1cfcf",
        //   // background: "#fff",
        //   // padding: "20px",
        //   // overflow: "auto",
        // }}
      >
        <Container
          maxWidth="xl"
          sx={{
            paddingLeft: "0px !important",
            paddingRight: "0px !important",
          }}
        >
          <Box
            sx={{
              height: { xs: "auto", md: "100vh" },
              // border: "1px solid #d1cfcf",
              // borderRadius: "5px",
              paddingLeft: "0px !important",
              paddingRight: "0px !important",
              // padding: "0px 16px",
              overflow: "scroll",
            }}
          >
            {value === "0" && (
              <>
                {isOwnerOrTenantOrAdmin ||
                permissions?.["Setting:Company"]?.read ? (
                  <CompanyDetails />
                ) : (
                  <NoPermissionPage />
                )}
              </>
            )}

            {value === "1" && (
              <>
                {isOwnerOrTenantOrAdmin ||
                permissions?.["Setting:Role"]?.read ? (
                  <RoleDetails />
                ) : (
                  <NoPermissionPage />
                )}
              </>
            )}

            {value === "2" && (
              <>
                {isOwnerOrTenantOrAdmin ||
                permissions?.["Setting:Staff"]?.read ? (
                  <UserDetails />
                ) : (
                  <NoPermissionPage />
                )}
              </>
            )}

            {value === "3" && <VehicleTypeSetting />}

            {value === "4" && (
              <DocumentsDetails
                settingFeedbackModulePermission={
                  settingFeedbackModulePermission
                }
                settingDocumentModulePermission={
                  settingDocumentModulePermission
                }
              />
            )}

            {value === "5" && <RefferList />}

            {value === "6" && (
              <>
                {isOwnerOrTenantOrAdmin || permissions?.["Setting"]?.read ? (
                  <MaterialList />
                ) : (
                  <NoPermissionPage />
                )}
              </>
            )}

            {value === "9" && <OdtTemplate />}

            {value === "10" && <QuickBookLog />}

            {value === "11" && <SkillsList />}

            {value === "12" && <SalesList />}

            {value === "13" && <GeneralInfo />}

            {/* {value === "14" && (
              <>
                {isOwnerOrTenantOrAdmin ||
                permissions?.["Setting: Customer"]?.read ||
                permissions?.["Setting:Customer"]?.read ? (
                  <CustomerMerge />
                ) : (
                  <NoPermissionPage />
                )}
              </>
            )} */}

            {value === "15" && <ClientStorageManagement />}

            {value === "16" && (
              <>
                <Tabs
                  value={communicationTab}
                  onChange={handleCommunicationTabChange}
                  sx={{ marginBottom: "16px" }}
                >
                  <Tab
                    value="leadEmailAutomation"
                    label="New Lead Email Automation"
                  />
                  <Tab value="emailTemplate" label="Email Template" />
                  <Tab value="smsTemplate" label="SMS Template" />
                </Tabs>
                {communicationTab === "leadEmailAutomation" && (
                  <>
                    {isOwnerOrTenantOrAdmin ||
                    permissions?.["Setting: Communications"]?.read ||
                    permissions?.["Setting:Communications"]?.read ? (
                      <LeadEmailAutomation />
                    ) : (
                      <NoPermissionPage />
                    )}
                  </>
                )}
                {communicationTab === "emailTemplate" && (
                  <>
                    {isOwnerOrTenantOrAdmin ||
                    permissions?.["Communication: Email"]?.read ||
                    permissions?.["Communication:Email"]?.read ? (
                      <SuperAdminEmailTemplate />
                    ) : (
                      <NoPermissionPage />
                    )}
                  </>
                )}

                {communicationTab === "smsTemplate" && (
                  <>
                    {isOwnerOrTenantOrAdmin ||
                    permissions?.["Communication: SMS"]?.read ||
                    permissions?.["Communication:SMS"]?.read ? (
                      <SuperAdminSmsTemplate />
                    ) : (
                      <NoPermissionPage />
                    )}
                  </>
                )}
              </>
            )}
            {value === "17" && (
              <>
                {isOwnerOrTenantOrAdmin || permissions?.["Setting"]?.read ? (
                  <MainSurveySettingPage />
                ) : (
                  <NoPermissionPage />
                )}
              </>
            )}
            {value === "18" && (
              <>
                {isOwnerOrTenantOrAdmin ||
                permissions?.["Setting: Customer"]?.read ||
                permissions?.["Setting:Customer"]?.read ? (
                  <CustomerPortalSetting />
                ) : (
                  <NoPermissionPage />
                )}
              </>
            )}
            {value === "19" && (
              <>
                <StorageSettingTabs />
              </>
            )}
          </Box>
        </Container>
      </Grid>
    </Grid>
  );
};

export default ClientAdminSetting;
